/**
 * Import AddToCart
 *
 */
export function importAddToCartChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-AddToCart' */ '../AddToCartHeader/AddToCartHeader'
  ).then(({ default: AddToCartHeader }) => {
    const addToCart = new AddToCartHeader();
    addToCart.execute();
  });
}

/**
 * Import Alert
 *
 */
export function importAlertChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-AddAlert' */ '../../AddAlert/AddAlert'
  ).then(({ default: AddAlert }) => {
    new AddAlert();
  });
}

/**
 * Import Scroll To Top
 *
 */
export function importScrollToTopChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ScrollToTop' */ '../../ScrollToTop/ScrollToTop'
  ).then(({ default: ScrollToTop }) => {
    new ScrollToTop();
  });
}

/**
 * Import Loyalty Sidebar
 *
 */
export function importLoyaltyChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Loyalty' */ '../Loyalty/Loyalty'
  ).then(({ default: Loyalty }) => {
    new Loyalty();
  });
}

/**
 * Import Delivery Sidebar
 *
 */
export function importDeliveryChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Delivery' */ '../Delivery/Delivery'
  ).then(({ default: Delivery }) => {
    new Delivery();
  });
}

/**
 * Import Delete Product
 *
 */
export function importDeleteProductChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-DeleteProduct' */ '../DeleteProduct/DeleteProduct'
  ).then(({ default: DeleteProduct }) => {
    new DeleteProduct();
  });
}

/**
 * Import Buy product later
 *
 */
export function importBuyLaterChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-BuyLater' */ '../BuyLater/BuyLater'
  ).then(({ default: BuyLater }) => {
    new BuyLater();
  });
}

/**
 * Import Quantity
 *
 */
export function importQuantityChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Quantity' */ '../Quantity/Quantity'
  ).then(({ default: Quantity }) => new Quantity());
}

/**
 * Import Limited Stock
 *
 */
export function importLimitedStockChunks() {
  const limitedStockElement: HTMLElement = document.querySelector(
    '.js-productLimitedStock'
  );

  if (limitedStockElement) {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-LimitedStock' */ '../LimitedStock/LimitedStock'
    ).then(({ default: LimitedStock }) => new LimitedStock());
  }
}

/**
 * Import Overview Product
 *
 */
export function importOverviewProductChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Overview' */ '../OverviewProduct/OverviewProduct'
  ).then(({ default: OverviewProduct }) => new OverviewProduct());
}

/**
 * Import Promotion Code
 *
 */
export function importPromotionCodeChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-PromotionCode' */ '../PromotionCode/PromotionCode'
  ).then(({ default: PromotionCode }) => new PromotionCode());
}

/**
 * Import Previous Cart
 *
 */
export function importPreviousCartChunks() {
  if (!document.querySelector('#previous-cart-template')) return;

  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-PreviousCart' */ '../PreviousCart/PreviousCart'
  ).then(({ default: PreviousCart }) => new PreviousCart());
}
